export enum VariablesEnum {
    usuario_conade = 'conade-user',
    usuario = 'usuario'
}
